function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.17 4.68a.556.556 0 01.821 0L8 10.01l5.009-5.328a.556.556 0 01.82 0 .646.646 0 010 .873L8.412 11.32a.556.556 0 01-.822 0L2.17 5.554a.646.646 0 010-.873z",
  fill: "#2D2D2D"
});
function SvgChevronabajo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Chevron abajo.svg";
export { SvgChevronabajo as ReactComponent };